import { DoricElement } from "../DoricElement";
export class NavigationElement extends HTMLElement {
    constructor() {
        super(...arguments);
        this.elementStack = [];
    }
    get currentNode() {
        for (let i = 0; i < this.childNodes.length; i++) {
            if (this.childNodes[i] instanceof DoricElement) {
                return this.childNodes[i];
            }
        }
        return undefined;
    }
    push(element) {
        const currentNode = this.currentNode;
        if (currentNode) {
            this.elementStack.push(currentNode);
            this.replaceChild(element, currentNode);
        }
        else {
            this.appendChild(element);
        }
    }
    pop() {
        const lastElement = this.elementStack.pop();
        const currentNode = this.currentNode;
        if (lastElement && currentNode) {
            this.replaceChild(lastElement, currentNode);
            currentNode.onDestroy();
        }
        else {
            window.history.back();
        }
    }
}
